import React, { useState } from 'react'
import ConfirmationDialog from 'components/Modal/ConfirmationDialog/ConfirmationDialog';
import { useAddStationsMutation, useAssignChefsMutation, useAvailableChefsQuery, useDeleteStationsMutation, useGetStationsQuery, useUpdateStationsMutation } from './services';
import StationsContainer from './container';
import StationsModal from 'components/Modal/Stations/Stations';
import AssignChefModal from 'components/Modal/AssignChef/AssignChefModal';

const Stations = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [open, setOpen] = useState(false);
    const [editingPoints, setEditingPoints] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [delData, setDelData] = useState(false);
    const [openAssignChefs, setOpenAssignChefs] = useState(false);
    const [assignStation, setAssignStation] = useState(null);

    const { data: stationsData, isLoading, isError } = useGetStationsQuery();
    const { data: availableChefsData } = useAvailableChefsQuery(undefined, {skip: !openAssignChefs});

    const [addStations, { isLoading: adding }] = useAddStationsMutation();
    const [updateStations, { isLoading: updating }] = useUpdateStationsMutation();
    const [deleteStations, {isLoading: isDeleteLoading}] = useDeleteStationsMutation();
    const [assignChefs, {isLoading: isAssignChefsLoading}] = useAssignChefsMutation();

    const filteredItems = stationsData?.data?.records?.filter(cat =>
      cat.name.toLowerCase().includes(searchQuery.trim().toLowerCase())
    ) ?? [];


    const handleAddBtn = () => {
        setEditingPoints(null);
        setOpen(true);
    };

    const handleEdit = (point) => {
        setEditingPoints(point);
        setOpen(true);
    };
    
    const handleDelete = (point) => {
        setConfirmDialogOpen(true);
        setDelData(point);
    }

    const handleClose = () => {
        setOpen(false);
        setEditingPoints(null);
    };

    const handleSubmit = async (values, { setSubmitting, setErrors }) => {
        try {
        if (editingPoints) {
            await updateStations({ id: editingPoints.id, ...values }).unwrap();
        } else {
            await addStations(values).unwrap();
        }
        handleClose();
        } catch (error) {
        setErrors(error.data?.errors || {});
        } finally {
        setSubmitting(false);
        }
    };

    const handleConfirmDelete = async () => {
        try{
            const deleteResponse = await deleteStations(delData?.id);
            setConfirmDialogOpen(false);
        } catch(error) {
            console.log(error, "Error in Delete station")
        }
    }

    const handleAssignBtn = (station) => {
        setAssignStation(station);
        setOpenAssignChefs(true);
    };

    const handleAssignClose = () => {
        setAssignStation(null);
        setOpenAssignChefs(false);
    };

    const handleAssignSubmit = async (values, { setSubmitting, setErrors }) => {
        try {
            const body = { chef_ids: values.chefs }
            await assignChefs({
                id: assignStation?.id,
                body
            }).unwrap();
            handleAssignClose();
        } catch (error) {
            setErrors(error.data?.errors || {});
        } finally {
            setSubmitting(false);
        }
    };

    const assignedChefs = assignStation?.chefs || [];
    const availableChefs = (availableChefsData?.data || []).map(c => ({
    id: c.id,
    name: c.full_name,
    }));

    // Merge assigned + available, ensure uniqueness by id
    const chefOptions = [
        ...assignedChefs.map(c => ({ id: c.id, name: c.full_name || c.name })),
        ...availableChefs,
        ].filter(
        (chef, index, self) => index === self.findIndex(c => c.id === chef.id)
    );

  return (
    <>  
    <StationsContainer
        stationsData={filteredItems}
        loading={isLoading}
        error={isError}
        searchTxt={searchQuery}
        setSearchQuery={setSearchQuery}
        handleAddBtn={handleAddBtn}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleAssignBtn={handleAssignBtn}
    />

    <StationsModal
        open={open}
        onClose={handleClose}
        initialData={editingPoints}
        onSubmit={handleSubmit}
        loading={adding || updating}
    />

    <AssignChefModal
        open={openAssignChefs}
        onClose={handleAssignClose}
        initialData={{
            id: assignStation?.id,
            name: assignStation?.name,
            assignedChefs: assignStation?.chefs || [],   // ✅ pass assigned chefs array
        }}
        onSubmit={handleAssignSubmit}
        loading={isAssignChefsLoading}
        // chefOptions={(availableChefsData?.data || []).map(c => ({
        //     id: c.id,
        //     name: c.full_name,
        // }))}
        chefOptions={chefOptions}
    />

    <ConfirmationDialog
        open={confirmDialogOpen}
        handleClose={() => setConfirmDialogOpen(false)}
        handleConfirm={handleConfirmDelete}
        btnText="Delete"
        infoText={`Are you sure you want to delete this ${delData?.name}?`}
        isLoading={isDeleteLoading}
        action={"Delete"}
    />
    </>
  )
}

export default Stations;
